import * as React from 'react';
import { ClientField } from '../sic-lib/types/ClientField';
import { ViewProperty, ViewPropertyExtended } from '../sic-lib/types/ViewProperty';
import { hasMatchingFieldId } from '../sic-lib/utils/functionalFilters';
import { mapViewPropertiesToField } from '../sic-lib/utils/functionalMappers';
import { sortByOrderNumAscending } from '../sic-lib/utils/functionalSort';

/**
 * useLabeledProperties
 *
 * @description
 * Adds a field label to ViewProperty objects by matching a ViewProperty to a
 * ClientCustomField using fieldId
 *
 * @param viewProperties
 * @param customFields
 */
export default function useLabeledProperties(
    viewProperties: ViewProperty[] = [],
    clientFields: ClientField[],
): ViewPropertyExtended[] {
    const [list, setList] = React.useState<ViewPropertyExtended[]>([]);

    React.useEffect(() => {
        const labeledProps = viewProperties.map(itm =>
            mapViewPropertiesToField(clientFields.filter(hasMatchingFieldId(itm.fieldId))[0])(itm),
        );
        const sortedProps = labeledProps.sort(sortByOrderNumAscending);

        setList(sortedProps);
    }, [viewProperties, clientFields]);

    return list;
}
